webpackJsonp([201317495999655],{

/***/ 1195:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.QKPortalPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get2 = __webpack_require__(14);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _BreakoutBox = __webpack_require__(444);
	
	var _BreakoutBox2 = _interopRequireDefault(_BreakoutBox);
	
	var _JoinBanner = __webpack_require__(64);
	
	var _JoinBanner2 = _interopRequireDefault(_JoinBanner);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	__webpack_require__(1195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var QKPortalPageTemplate = exports.QKPortalPageTemplate = function QKPortalPageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      image = _ref.image,
	      boxTitle = _ref.boxTitle,
	      boxContent = _ref.boxContent,
	      features = _ref.features,
	      rawMarkdownBody = _ref.rawMarkdownBody,
	      footerSettings = _ref.footerSettings,
	      meta = _ref.meta;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'QKPortalPage' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title, subtitle: subtitle }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-columns background-dots' },
	        image && _react2.default.createElement(_Image2.default, { src: image, alt: title }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container content' },
	          _react2.default.createElement(
	            _BreakoutBox2.default,
	            { title: boxTitle },
	            boxContent && _react2.default.createElement(_Content2.default, { src: boxContent })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'features' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container content' },
	          features && _react2.default.createElement(
	            'h3',
	            null,
	            features.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'features-list' },
	            features && features.featuresItem.map(function (item, index) {
	              var icon = item.icon,
	                  description = item.description;
	
	              return _react2.default.createElement(
	                'div',
	                { className: 'features-item', key: index },
	                icon && _react2.default.createElement(
	                  'div',
	                  { className: 'features-icon' },
	                  _react2.default.createElement(_Image2.default, { src: icon, alt: 'features icon' })
	                ),
	                description && _react2.default.createElement(_Content2.default, { src: description })
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin JoinBannerSection' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_JoinBanner2.default, { linkTo: '/' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	      )
	    )
	  );
	};
	
	var QKPortalPage = function QKPortalPage(_ref2) {
	  var data = _ref2.data;
	  var page = data.markdownRemark,
	      footerSettings = data.footerSettings;
	
	
	  return _react2.default.createElement(QKPortalPageTemplate, _extends({}, page, page.frontmatter, { footerSettings: footerSettings }));
	};
	
	exports.default = QKPortalPage;
	
	// Query for QKPortalPage data
	// Use GraphiQL interface (http://localhost:8000/___graphql)
	// ID is processed via gatsby-node.js
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-qk-portal-page-js-54c781d7c0067433fdba.js